import styled from "styled-components";

import { $dmSansFontFamily, colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { IconButton, LinkElement } from "@similarweb/ui-components";
import { Box, Flex, Stack } from "@similarweb/ui-components/foundations";

const BANNER_PADDING_X_PX = 32;
const TEXT_COLUMN_WIDTH_PX = 507;

const ILLUSTRATION_WIDTH_PX = 337;
const ILLUSTRATION_HEIGHT_PX = 171;
const ILLUSTRATION_FADE_WIDTH_PX = 90;
/** Where the fade reaches full opacity — past it the strip is solid, hiding the pills' ragged ends. */
const ILLUSTRATION_FADE_STOP = "84%";

/** Every pill metric is a fraction of its own font size, so the four sizes stay one coherent illustration. */
const PILL_PADDING_X_EM = 8 / 7;
const PILL_PADDING_Y_EM = 4 / 7;
const PILL_SHADOW_BLUR_EM = 2.5 / 7;
const PILL_LINE_HEIGHT_RATIO = 12 / 7;

export const StyledBannerWrapper = styled(Flex)`
    position: relative;
    padding: 24px ${BANNER_PADDING_X_PX}px;
    border-radius: 6px;
    background-color: ${colorsPalettes.blue[100]};
    overflow: hidden;
`;

export const StyledBannerCloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 8px;
`;

export const StyledBannerTextColumn = styled(Stack)`
    flex: 0 0 auto;
    width: ${TEXT_COLUMN_WIDTH_PX}px;
    max-width: 100%;
`;

/**
 * `LinkElement` derives `href` from its own `url` prop — passing `href` directly is silently overwritten.
 */
export const StyledLearnMoreLink = styled(LinkElement)`
    ${setFontVariant("body2", colorsPalettes.blue[400])};

    &:hover {
        color: ${colorsPalettes.blue[500]};
        text-decoration: underline;
    }
`;

/**
 * The design runs the illustration flush to the banner's outer edge (32 + 507 + 24 + 337 = 900), so it bleeds through
 * the right padding. Without that bleed the box narrows and drags the fade left, swallowing the first pill's end.
 */
export const StyledIllustrationWrapper = styled(Box)`
    position: relative;
    flex: 0 0 ${ILLUSTRATION_WIDTH_PX}px;
    margin-right: -${BANNER_PADDING_X_PX}px;
    height: ${ILLUSTRATION_HEIGHT_PX}px;
    overflow: hidden;
`;

export const StyledIllustrationFade = styled(Box)`
    position: absolute;
    top: 0;
    right: 0;
    width: ${ILLUSTRATION_FADE_WIDTH_PX}px;
    height: 100%;
    background: linear-gradient(
        90deg,
        ${rgba(colorsPalettes.blue[100], 0)} 0%,
        ${colorsPalettes.blue[100]} ${ILLUSTRATION_FADE_STOP}
    );
`;

export const StyledTaxonomyPill = styled(Box)<{ $fontSize: number; $left: number; $top: number }>`
    position: absolute;
    left: ${({ $left }) => $left}px;
    top: ${({ $top }) => $top}px;
    font-family: ${$dmSansFontFamily};
    font-weight: 700;
    font-size: ${({ $fontSize }) => $fontSize}px;
    line-height: ${PILL_LINE_HEIGHT_RATIO};
    white-space: nowrap;
    color: ${colorsPalettes.bluegrey[600]};
    background-color: ${colorsPalettes.bluegrey[100]};
    padding: ${PILL_PADDING_Y_EM}em ${PILL_PADDING_X_EM}em;
    border-radius: ${PILL_PADDING_X_EM}em;
    box-shadow: ${PILL_PADDING_Y_EM}em ${PILL_PADDING_Y_EM}em ${PILL_SHADOW_BLUR_EM}em
        ${rgba(colorsPalettes.black[0], 0.08)};
`;
